namespace GeniuzPOS.Member {
    export interface MbReportSaleByDateRow {
        Id?: string;
        MbId?: string;
        MbType?: string;
        MemberTypeDesc?: string;
        MbNameT?: string;
        MbNameE?: string;
        MbAddress?: string;
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
        MbZipCode?: string;
        MbGender?: string;
        MbNation?: string;
        MbRace?: string;
        MbOccupation?: string;
        MbBirthDay?: string;
        MbCardStatus?: number;
        MbAccumPoint?: number;
        MbMemo?: string;
        DocDate?: string;
        CountDocNo?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
    }

    export namespace MbReportSaleByDateRow {
        export const idProperty = 'Id';
        export const nameProperty = 'MbId';
        export const localTextPrefix = 'Member.MbReportSaleByDate';
        export const deletePermission = '3Member:สถานะสมาชิก:View';
        export const insertPermission = '3Member:สถานะสมาชิก:View';
        export const readPermission = '3Member:สถานะสมาชิก:View';
        export const updatePermission = '3Member:สถานะสมาชิก:View';

        export declare const enum Fields {
            Id = "Id",
            MbId = "MbId",
            MbType = "MbType",
            MemberTypeDesc = "MemberTypeDesc",
            MbNameT = "MbNameT",
            MbNameE = "MbNameE",
            MbAddress = "MbAddress",
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol",
            MbZipCode = "MbZipCode",
            MbGender = "MbGender",
            MbNation = "MbNation",
            MbRace = "MbRace",
            MbOccupation = "MbOccupation",
            MbBirthDay = "MbBirthDay",
            MbCardStatus = "MbCardStatus",
            MbAccumPoint = "MbAccumPoint",
            MbMemo = "MbMemo",
            DocDate = "DocDate",
            CountDocNo = "CountDocNo",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge"
        }
    }
}
